// extracted by mini-css-extract-plugin
module.exports = {"follow-control":"_3rb_W4YABTYXfZOBzHHxLD"};